.container {
  display: flex;
}

.search-field {
  height: 24px;
  margin-left: auto;
  border: 1px solid var(--field-border);
  border-right: 0;
}

.search-button {
  display: flex;
  background-color: white;
  border: 1px solid var(--field-border);
  border-left: 0;
  padding-left: 4px;
  padding-right: 4px;
  cursor: pointer;
}

.search-button svg {
  width: 1rem;
}

.result-table-container {
  background-color: white;
  width: 550px;
  height: 400px;
  border: 1px solid var(--field-border);
  margin-top: 10px;
  overflow: auto;
}

.result-table-headers th {
  padding: 3px 5px;
  background-color: var(--dialog-headers-background);
  text-align: left;
  border-bottom: 1px solid var(--field-border);
}

.result-table {
  width: 100%;
}

.result-table.full-heigth {
  height: 100%;
}

.description-text {
  padding: 5px;
  text-align: center;
  vertical-align: top;
  font-size: 0.9em;
}

.loading-image-container {
  text-align: center;
}

.selected-item {
  background-color: var(--dialog-selected-item);
}

.buttons {
  padding-top: 15px;
  display: flex;
  column-gap: 1em;
  justify-content: end;
}
